import dagre from 'dagre';
import { isNode } from 'react-flow-renderer';
import {
  ACTION, ACTION_EDGE, CONDITION, START_PROCESS, TRIGGER
} from './Process/constants';
import { Edge, Step } from '../../types';

const getStepType = (step: Step) => {
  if (step.action) {
    if (step.action.condition) {
      return CONDITION;
    }
    return ACTION;
  } if (step.trigger) {
    return TRIGGER;
  }
  return START_PROCESS;
};

export const workflowToElements = (workflow: any, nodeProps?: any) => {
  const initialElements: any = [];

  workflow.steps.forEach((step: Step) => {
    initialElements.push(({
      id: step.id,
      type: getStepType(step),
      draggable: false,
      data: {
        label: step.name,
        // eslint-disable-next-line no-nested-ternary,max-len
        step,
        ...nodeProps
      },
    }));
  });
  workflow.edges.forEach((edge: Edge) => {
    initialElements.push({
      id: edge.id,
      type: ACTION_EDGE,
      source: edge.fromStepId,
      target: edge.toStepId,
      animated: true,
    });
  });

  return initialElements;
};


export const NODE_WIDTH = 200;
export const NODE_HEIGHT = 50;

export const getLayoutedElements = (elements: any[]) => {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({ rankdir: 'TB' });

  elements.forEach((el) => {
    if (isNode(el)) {
      dagreGraph.setNode(el.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
    } else {
      dagreGraph.setEdge(el.source, el.target);
    }
  });

  dagre.layout(dagreGraph);

  return elements.map((el) => {
    if (isNode(el)) {
      const nodeWithPosition = dagreGraph.node(el.id);

      return {
        ...el,
        targetPosition: 'top',
        sourcePosition: 'bottom',
        position: {
          x: nodeWithPosition.x,
          y: nodeWithPosition.y,
        },
      };
    }

    return el;
  });
};
